








import { Component, Vue, Emit } from 'vue-property-decorator';
import DepartmentForm from '@/components/Department/DepartmentForm.vue';
import { ALL_DEPARTMENTS, departmentFragments } from '@/queries/Department';
import { InMemoryCache } from 'apollo-cache-inmemory';
import { GQL_currentUnitDepartments } from '@/queries/__generated__/currentUnitDepartments';
import { GQL_createDepartment, GQL_createDepartmentVariables } from '@/queries/__generated__/createDepartment';
import { GQL_currentUnit, GQL_currentUnit_currentUnit } from '@/queries/__generated__/currentUnit';
import { CURRENT_UNIT } from '@/queries/Application';
import { SmartQuery } from 'vue-apollo-decorator';
import gql from 'graphql-tag';

const CREATE_DEPARTMENT = gql`
  mutation createDepartment(
    $code: String!,
    $name: String!,
    $unitId: ID!,
  ) {
    createDepartment(
      input: {
        department: {
          code: $code,
          name: $name,
          unitId: $unitId,
        }
      }
    ) {
      department {
        ...departmentFragments
      }
    }
  },
  ${departmentFragments}
`;

@Component({
  components: {
    DepartmentForm,
  },
})
export default class DepartmentNew extends Vue {
  @SmartQuery<DepartmentNew, GQL_currentUnit>({
    query: CURRENT_UNIT,
    result({ data }) {
      this.data.unitId = data.currentUnit.id;
    },
  }) public currentUnit!: GQL_currentUnit_currentUnit;

  public CREATE_DEPARTMENT = CREATE_DEPARTMENT;
  public data: GQL_createDepartmentVariables = {
    code: '',
    name: '',
    unitId: '',
  };

  @Emit('department-created')
  public addToCache(store: InMemoryCache, query: {data: GQL_createDepartment }) {
    const data = (store.readQuery({ query: ALL_DEPARTMENTS }) as GQL_currentUnitDepartments);
    if (!data.currentUnit || !query.data.createDepartment?.department) return;
    const department = query.data.createDepartment!.department!;
    data.currentUnit.departments.push(department);
    store.writeQuery({ query: ALL_DEPARTMENTS, data });
    return department;
  }
}
